<template>
  <div>
    <v-btn
      absolute
      flat
      right
      @click="dialog = true"
      style="top: 10px; background-color: #fddf00; width: 230px; height: 40px"
    >
      <v-icon color="black" style="font-size: 35px">add</v-icon>
      <h3>COMMISSION Withdraw</h3>
    </v-btn>
    <withdrawDialog
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
      @onSaved="createWithdrawForm($event)"
    ></withdrawDialog>
    <EditWithdraw
      :selectedItem="selectedItem"
      :newUserDialog="editDialog"
      :buttonDelete="buttonDelete"
      @setDialog="editDialog = $event"
      @onSaved="editWithdraw($event)"
    ></EditWithdraw>
    <v-toolbar dense flat>
      <v-layout row>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search district / province"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filterWithdrawList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{
            pagination.page * pagination.rowsPerPage -
              (pagination.rowsPerPage - props.index - 1)
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_withdraw_province.province_name_th }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_withdraw_district.district_name_th }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_withdraw_type == 1 ? "Credit" : "Percent" }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_withdraw_amount }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_withdraw_commission_maximum }}
        </td>
        <td>
          <v-btn icon @click="editItem(props.item)"
            ><v-icon small>edit</v-icon>
          </v-btn>
          <v-btn icon @click="toDeleteItem(props.item)" :loading="isDeleting">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="deleteDialog" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title class="px-4"
          ><h2>Are you want to delete this commission withdraw?</h2>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="pr-5 py-4">
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            color="red"
            style="
                  width: 120px;
                  border-radius: 7px;
                  font-weight: bold;
                  font-size: 16px;
                "
            @click="deleteDialog = false"
            :loading="changingLoading"
            >cancel</v-btn
          >
          <v-btn
            flat
            dark
            color="black"
            style="
                  width: 120px;
                  background-color: #fddf00;
                  border-radius: 7px;
                  font-weight: bold;
                  font-size: 16px;
                "
            @click="deleteItem()"
            :loading="changingLoading"
            >confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import withdrawDialog from "./CommissionWithdraw.vue";
import EditWithdraw from "./EditcommissionWithdraw";
export default {
  data: () => ({
    buttonDelete: false,
    changingLoading: false,
    deleteDialog: false,
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    dialog: false,
    editDialog: false,
    isDeleting: false,
    selectedItem: {
      commission_withdraw_province: {},
      commission_withdraw_district: {},
    },
    headers: [
      {
        text: "No.",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "Province",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "District",
        sortable: false,
        value: "",
        align: "center",
      },
      {
        text: "Commission Type",
        sortable: false,
        value: "",
        align: "center",
      },
      {
        text: "Commission",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "Maximum Commission",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "Actions",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    withdrawDialog,
    EditWithdraw,
  },
  computed: {
    ...mapState({
      withdrawlist: (state) => state.fetchWithdraw.withdrawlist,
    }),
    filterWithdrawList() {
      return this.withdrawlist.filter(
        (val) =>
          (
            val.commission_withdraw_province.province_name_th +
            " " +
            val.commission_withdraw_district.district_name_th
          )
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          (
            val.commission_withdraw_district.district_name_th +
            " " +
            val.commission_withdraw_province.province_name_th
          )
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      createWithdraw: "fetchWithdraw/commissionWithdraw",
      editCreate: "fetchWithdraw/commissionWithdrawEdit",
    }),

    editItem(item) {
      let userItem = JSON.parse(JSON.stringify(item));
      this.selectedItem = userItem;
      this.editDialog = true;
    },

    toDeleteItem(item) {
      this.deleteDialog = true;
      this.selectedItem = JSON.parse(JSON.stringify(item));
    },

    async deleteItem() {
      this.isDeleting = true;
      let result = await this.$store.dispatch(
        "fetchWithdraw/deleteCommissionWithdraw",
        this.selectedItem.commission_withdraw_id
      );
      this.isDeleting = false;
      if (result == false) return;
      let index = this.withdrawlist.findIndex(
        (val) =>
          val.commission_withdraw_id == this.selectedItem.commission_withdraw_id
      );
      this.withdrawlist.splice(index, 1);
      this.deleteDialog = false;
    },

    async createWithdrawForm(item) {
      this.loadingMessage = true;
      await this.createWithdraw(item.form);
      item.done();
      await this.$store.dispatch("fetchWithdraw/fetchWithdrawList");
      this.loadingMessage = false;
      this.dialog = false;
    },

    async editWithdraw(item) {
      this.loadingMessage = true;
      await this.editCreate(item.form);
      item.done();
      await this.$store.dispatch("fetchWithdraw/fetchWithdrawList");
      this.loadingMessage = false;
      this.editDialog = false;
    },

    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("fetchWithdraw/fetchWithdrawList");
      this.loadingMessage = false;
    },

    async deleteBank(payload) {
      payload.done();
      this.dialog = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>
